import { store } from 'store/store';
import { logoutAction } from 'store/login/loginAction';
import {
  PAGE_NOT_FOUND_HREF,
  PAGE_SERVICE_UNAVAILABLE_HREF,
  redirectToErrorPage,
} from 'shared/constants/errorPages';
import { API_URL } from 'utils';
import { DetailedError } from './DetailedError';

export const fetchApi = async (
  endpoint,
  options = {},
  headersToRemove = [],
  redirect404 = false,
  redirect500 = true,
  absolutePath = false,
) => {
  let requestUrl = absolutePath ? `${endpoint}` : `${API_URL}${endpoint}`;

  const { token } = store.getState().auth.data;

  const headers = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${token}`,
    ...options.headers,
  };

  headersToRemove.forEach((header) => {
    delete headers[header];
  });

  if (options.query) {
    const params = new URLSearchParams(options.query);
    requestUrl += `?${params.toString()}`;
  }

  return fetch(requestUrl, {
    ...options,
    headers,
  }).then((response) => {
    if ([401].indexOf(response.status) >= 0) {
      store.dispatch(logoutAction);
      return Promise.reject(response);
    }
    if (response.status === 404 && redirect404) {
      redirectToErrorPage(PAGE_NOT_FOUND_HREF);
      return Promise.reject(response);
    }
    if (redirect500 && [500, 501, 502, 503, 504, 505].includes(response.status)) {
      redirectToErrorPage(PAGE_SERVICE_UNAVAILABLE_HREF);
      return Promise.reject(response);
    }
    if (!response.ok) {
      return Promise.reject(response);
    }
    return response;
  });
};

export const catchFetchApiError = async (response) => {
  await response.json().then((resp) => {
    let message = resp.message || '';
    if (!message && resp && typeof resp === 'string') message = resp;
    throw new DetailedError(message, response.status, resp);
  });
};

export const getFetchApiJSONResponse = (response) => response.json();

export const getFetchApiTextResponse = (response) => response.text();
